export const EMBEDDABLES_STORAGE_SENTINEL_KEY = 'EmbeddablesStorageSentinel'

export type StorageSentinelInspection = {
  sentinel_present: boolean
  sentinel_written_at: string | null
  sentinel_read_error: string | null
}

function formatSentinelError(error: unknown): string {
  if (error instanceof Error) return `${error.name}: ${error.message}`
  return String(error)
}

//* Diagnostic read of the sibling sentinel key written next to SavvyFormUserData.
//* Uses raw localStorage.getItem so getItem failures are visible (same pattern as
//* inspectSavvyFormUserDataRead — localStorageGet swallows errors).
export function inspectStorageSentinel(): StorageSentinelInspection {
  try {
    const raw = localStorage.getItem(EMBEDDABLES_STORAGE_SENTINEL_KEY)
    if (raw === null) {
      return {
        sentinel_present: false,
        sentinel_written_at: null,
        sentinel_read_error: null,
      }
    }

    return {
      sentinel_present: true,
      sentinel_written_at: raw,
      sentinel_read_error: null,
    }
  } catch (error) {
    return {
      sentinel_present: false,
      sentinel_written_at: null,
      sentinel_read_error: formatSentinelError(error),
    }
  }
}
